import pkg from "color-convert";
import type { FcColor } from "@dtx-company/flowcode-generator-v2";

const { hex } = pkg;
// convertConfigHexToCMYK takes in a hex string and converts it to a hex:cmyk string
// compatible with the generator
export function convertConfigHexToCMYK(value: string): string {
	const cmykValues = hex.cmyk(value);
	const cmykString = cmykValues.join(" ");

	return formatFcColor(value, `(${cmykString})`);
}

export function convertConfigCMYKToHex(value: string): string {
	const parts = value.split(":");

	if (parts.length > 0) {
		return parts[0]; // Return the hex portion
	}

	return value;
}
export function convertCMYKToHex(c: number, m: number, y: number, k: number): string {
	const [r, g, b] = pkg.cmyk.rgb([c, m, y, k]);
	return `#${pkg.rgb.hex(r, g, b)}`;
}

/**
 * Convert a cmyk input as typed by the user into a cmyk string that the generator can use
 *
 * @returns The same cmyk values on a space-separated string in parenthesis that the generator
 * can use. For exampe:  "(20 89 12 5)"
 */
export function cmykInputToFcColorFormat(c: number, m: number, y: number, k: number): string {
	return `(${c} ${m} ${y} ${k})`;
}

export function formatFcColor(hexRgb: string, cmyk?: string): FcColor {
	const cmykPart = cmyk ? `:${cmyk}` : "";
	return `${hexRgb}${cmykPart}`;
}
